exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-button_close-container_12PED {\n    width: 55px;\n    height: 55px;\n    position: absolute;\n    right: 4px;\n    top: 0px;\n    font-size: 0;\n    line-height: 32px;\n    cursor: pointer;\n    text-align: center;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.close-button_close-container_12PED img {\n    width: 16px;\n    height: 16px;\n}", ""]);

// exports
exports.locals = {
	"close-container": "close-button_close-container_12PED",
	"closeContainer": "close-button_close-container_12PED"
};